var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    y: 0.97,
    fill: "#fff",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E0F0C",
    fillRule: "evenodd",
    d: "M33.425 17.684c.476 0 .862.386.862.862v6.423c0 .237-.2.424-.415.526-.16.077-.301.187-.416.322-.144.167-.256.36-.33.568-.084.233-.126.48-.125.728 0 .255.044.502.126.728.08.225.196.416.328.567s.276.256.417.323c.203.096.393.268.413.486h.002v2.606a.86.86 0 0 1-.862.86H14.577a.86.86 0 0 1-.862-.86V18.546c0-.476.386-.862.862-.862zm-.853 12.242v1.044H15.429V19.399h17.143v4.9a3 3 0 0 0-.407.39c-.278.318-.5.696-.65 1.112a3.88 3.88 0 0 0 0 2.624c.15.416.372.794.65 1.112q.19.216.407.39zm-15-5.813h2.572v-1.714H17.57z",
    clipRule: "evenodd"
  })));
};
export default SvgMoney;